// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgViewTogether24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M17.4443 9.34491C18.3092 9.82666 18.8576 10.7399 18.8576 11.7486C18.8576 12.8015 18.2601 13.748 17.3351 14.2099C16.9645 14.395 16.5141 14.2446 16.329 13.8741C16.1594 13.5344 16.2716 13.1276 16.5769 12.9196L16.6649 12.868C17.0862 12.6576 17.3576 12.2276 17.3576 11.7486C17.3576 11.3355 17.1559 10.9583 16.8282 10.7269L16.7144 10.6554C16.3525 10.4538 16.2226 9.99707 16.4241 9.6352C16.6257 9.27333 17.0824 9.14336 17.4443 9.34491ZM15.75 12.0001C15.75 10.4814 14.5188 9.25014 13 9.25014C11.4812 9.25014 10.25 10.4814 10.25 12.0001C10.25 13.5189 11.4812 14.7501 13 14.7501C14.5188 14.7501 15.75 13.5189 15.75 12.0001ZM18.25 19.3335C18.25 17.0843 16.4814 15.2501 14.2857 15.2501H11.7143C9.51865 15.2501 7.75 17.0843 7.75 19.3335V21.0001C7.75 21.4143 8.08579 21.7501 8.5 21.7501H17.5C17.9142 21.7501 18.25 21.4143 18.25 21.0001V19.3335ZM22.0833 19.3335C22.0819 17.4721 20.8226 15.8475 19.0208 15.3823C18.6198 15.2787 18.2107 15.5199 18.1071 15.921C18.0036 16.322 18.2448 16.7311 18.6458 16.8347C19.7857 17.129 20.5825 18.1568 20.5833 19.334V21.0001C20.5833 21.4143 20.9191 21.7501 21.3333 21.7501C21.7475 21.7501 22.0833 21.4143 22.0833 21.0001V19.3335ZM14.2857 16.7501H11.7143C10.3595 16.7501 9.25 17.9008 9.25 19.3335V20.2501H16.75V19.3335C16.75 17.9581 15.7275 16.8426 14.4471 16.7556L14.2857 16.7501ZM11.75 12.0001C11.75 11.3098 12.3096 10.7501 13 10.7501C13.6904 10.7501 14.25 11.3098 14.25 12.0001C14.25 12.6905 13.6904 13.2501 13 13.2501C12.3096 13.2501 11.75 12.6905 11.75 12.0001Z"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M19 4C20.6569 4 22 5.34315 22 7V15H20.5V7C20.5 6.17157 19.8284 5.5 19 5.5H5C4.17157 5.5 3.5 6.17157 3.5 7V16C3.5 16.8284 4.17157 17.5 5 17.5H6V19H5C3.34315 19 2 17.6569 2 16V7C2 5.34315 3.34315 4 5 4H19Z"
				/>
			</Svg>
		);
	}
);
SvgViewTogether24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgViewTogether24;
